import actions from './actions'

export default function InventoryClasssReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVENTORYCLASS:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVENTORYCLASS:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVENTORYCLASS:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVENTORYCLASS:
      return {
        ...state,
        editing: { classID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_INVENTORYCLASS_RECIEVED ||
      actions.UPDATE_INVENTORYCLASS_RECIEVED ||
      actions.DELETE_INVENTORYCLASS_RECIEVED:
      return {
        ...state,
        editing: { classID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
